module.exports = __webpack_public_path__ + "img/blog13.cc3f50ff.jpg";